// 手机菜单是否展开
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_MASK = 'TOGGLE_MASK';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js